import { RecetaService } from "@/service/services/Receta.service";
import { Alert, Autocomplete, CircularProgress, Divider, Grid, Snackbar, TextField, Tooltip, Typography } from "@mui/material";
import React, { FC, useEffect, useState } from "react";
import { Popup } from "../Editor/components/Popup";
import { Form, Formik } from "formik";
import PriorityHighIcon from '@mui/icons-material/PriorityHigh';
import { KEY_EMPRESA } from "@/toolbox/constants/local-storage";
import { readLocalStorage } from "@/toolbox/helpers/local-storage-helper";
import { productoService } from "@/service/services/Producto.service";

interface RecetaModalProps {
    open: boolean
    setOpenPopup: React.Dispatch<React.SetStateAction<boolean>>
    action: string
    rowSelected: any
    onList: () => Promise<void>
    idproducto: number
}

export const RecetaModal: FC<RecetaModalProps> = (props) => {
    const { open, setOpenPopup, action, rowSelected, onList, idproducto } = props

    const dataEmpresa = readLocalStorage(KEY_EMPRESA);

    const [title, setTitle] = useState<string>('')
    const [data, setData] = useState({
        id: rowSelected?.id || 0,
        idproducto: rowSelected?.idproducto || 0,
        idinsumo: rowSelected?.idinsumo || 0,
        cantidad: rowSelected?.cantidad || 1,
    });
    const [snackBarConfig, setSnackBarConfig] = useState<any>({
        open: false,
        severity: 'error',
        message: 'Error',
        autoHideDuration: 3000,
    });
    const [loading, setLoading] = useState<boolean>(false)
    const [loadingSubmit, setLoadingSubmit] = useState<boolean>(false)
    const [insumos, setInsumos] = useState<any[]>([])
    const [insumoSelected, setInsumoSelected] = useState<any>(null)

    useEffect(() => {
        switch (action) {
            case 'create':
                setTitle('Crear producto')
                break;

            case 'edit':
                setTitle('Editar producto')
                break;

            default:
                break;
        }
    }, [action])

    useEffect(() => {
        getCombosBoxesAPI()
    }, [])

    useEffect(() => {
        if (action === 'edit' && rowSelected?.idinsumo && insumos.length > 0) {
            const insumo = insumos.find(insumo => insumo.id === rowSelected.idinsumo)
            console.log('insumo', insumo)
            setInsumoSelected(insumo || null)
        }
    }, [action, rowSelected, insumos])

    const getCombosBoxesAPI = async () => {
        setLoading(true)
        const response = await productoService.getProductosInsumo(dataEmpresa.id)
        setInsumos(response.productos || [])
        setLoading(false)
    }

    const validateForm = (values) => {
        let errors: any = {};

        if (values.idinsumo < 1) errors.idinsumo = "campo es requerido";
        if (values.cantidad < 1) errors.cantidad = "campo es requerido";

        return errors;
    }

    const onSubmit = async (values) => {
        setLoadingSubmit(true)
        try {
            const payload = {
                idproducto: idproducto,
                idinsumo: values.idinsumo,
                cantidad: values.cantidad
            }

            await (action === 'create' ? RecetaService.addInsumo(payload) : RecetaService.updateInsumo(rowSelected.id, payload))
            setOpenPopup(false)
            onList()
        } catch (error) {
            console.error("Error:", error);
        }
        setLoadingSubmit(false)
    }

    return (<>
        <Snackbar
            open={snackBarConfig.open}
            autoHideDuration={snackBarConfig.autoHideDuration}
            onClose={() => setSnackBarConfig(prev => ({ ...prev, open: false }))}
            anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
        >
            <Alert
                onClose={() => setSnackBarConfig(prev => ({ ...prev, open: false }))}
                severity={snackBarConfig.severity}
                variant="filled"
            >
                {snackBarConfig.message}
            </Alert>
        </Snackbar>

        <Popup
            largo="sm"
            title={title}
            openPopup={open}
            setOpenPopup={setOpenPopup}
        >
            <Formik enableReinitialize initialValues={data} validate={(values) => validateForm(values)} onSubmit={onSubmit}>
                {({ values, errors, touched, handleSubmit, handleChange, setFieldValue }) => {
                    return (
                        <Form onSubmit={handleSubmit}>
                            <Grid container spacing={3} alignItems="center" justifyContent="center">
                                <Grid item xs={12} container style={{ display: "flex", alignItems: "center" }}>
                                    <Grid item xs={4}>
                                        <Typography variant="subtitle1" className="custom-input"><b>Insumo:</b></Typography>
                                    </Grid>
                                    <Grid item xs={8} style={{ display: 'flex', alignItems: "center" }}>
                                        <Autocomplete
                                            key='cbx-insumo'
                                            id="cbx-insumo"
                                            size="small"
                                            value={insumoSelected || null}
                                            options={loading ? [] : insumos}
                                            getOptionLabel={(option) => option?.nombre || ''}
                                            isOptionEqualToValue={(option, value) => option.id === value?.id}
                                            renderInput={(params) =>
                                                <TextField {...params}
                                                    label=""
                                                    size="small"
                                                    InputProps={{
                                                        ...params.InputProps,
                                                        endAdornment: (
                                                            <React.Fragment>
                                                                {loading ? <CircularProgress color="inherit" size={20} /> : null}
                                                                {params.InputProps.endAdornment}
                                                            </React.Fragment>
                                                        ),
                                                    }}
                                                    error={errors.idinsumo && touched.idinsumo ? true : false}
                                                />}
                                            onChange={(e, newValue) => {
                                                setInsumoSelected(newValue)
                                                setFieldValue('idinsumo', newValue?.id || 0)
                                            }}
                                            fullWidth
                                            noOptionsText={!insumoSelected ? "Seleccione un insumo" : "Sin opciones"}
                                        />
                                    </Grid>
                                </Grid>

                                <Grid item xs={12} container style={{ display: "flex", alignItems: "center" }}>
                                    <Grid item xs={4}>
                                        <Typography variant="subtitle1" className="custom-input"><b>Cantidad:</b></Typography>
                                    </Grid>
                                    <Grid item xs={8} style={{ display: 'flex', alignItems: "center" }}>
                                        {
                                            errors.cantidad && (touched.cantidad ? true : false) && (
                                                <Tooltip title={errors.cantidad}>
                                                    <PriorityHighIcon className={'iconWarning'} />
                                                </Tooltip>
                                            )
                                        }
                                        <TextField
                                            id="cantidad"
                                            type="number"
                                            name="cantidad"
                                            fullWidth
                                            value={values.cantidad}
                                            onChange={handleChange}
                                            placeholder="Cantidad del producto"
                                            error={errors.cantidad && touched.cantidad ? true : false}
                                            inputProps={{ min: 1 }}
                                        />
                                    </Grid>
                                </Grid>

                            </Grid>

                            <Divider sx={{ my: 2 }} />

                            <div className="form-group mb-3 buton_container_modal">
                                <button type="submit" className="btn btn-primary" disabled={loadingSubmit}>
                                    {action === 'create' ? 'Agregar' : 'Actualizar'}
                                </button>
                            </div>

                        </Form>
                    )
                }}
            </Formik>
        </Popup>
    </>)
}